import {useTranslation} from 'react-i18next'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
} from '@chakra-ui/react'

import RenderPdf from '~/react/components/RenderPdf'
import {useTermsPdf} from '../../hooks/useTermsPdf'

const TermsAndConditionsModal = ({
  isOpen,
  onAccept,
  onCancel,
  isSubmitting,
}) => {
  const {t} = useTranslation('points')
  const {pdf, isLoading: loadingPdfDetails} = useTermsPdf(!isOpen)
  const {url: pdfUrl} = pdf || {}

  const submittingState = isSubmitting

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      size="full"
      closeOnOverlayClick={!submittingState}
      closeOnEsc={!submittingState}
    >
      <ModalOverlay />
      <ModalContent display="flex" flexDirection="column" height="100vh">
        <ModalHeader>{t('termsAndConditionsModal.title')}</ModalHeader>
        {!submittingState && <ModalCloseButton />}

        <ModalBody p={4} flex="1">
          {pdfUrl && <RenderPdf url={pdfUrl} />}
        </ModalBody>

        <ModalFooter flexShrink={0} justifyContent="flex-start">
          <Button
            mr="md"
            variant="primary"
            onClick={onAccept}
            isLoading={loadingPdfDetails || submittingState}
            loadingText={t('termsAndConditionsModal.buttons.accepting')}
          >
            {t('termsAndConditionsModal.buttons.accept')}
          </Button>
          <Button
            variant="secondary"
            mr={3}
            onClick={onCancel}
            isDisabled={submittingState}
          >
            {t('termsAndConditionsModal.buttons.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

TermsAndConditionsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
}

export default TermsAndConditionsModal
